/*eslint-disable  */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { UserSelectors } from 'store/userModule/selectors';
import NotPermission from './NotPermission';

const PERMISSION_TYPES = {
  USE_ADVANCE_SEARCH: 'USE_ADVANCE_SEARCH',
  USE_STORYBOARD: 'USE_STORYBOARD',
  USE_VERIFY: 'USE_VERIFY',
};

const mapStateToProps = state => ({
  myPermissionArray: state.app.permissionArray,
  isLogged: UserSelectors.isLoggedSelector(state),
  isPro: UserSelectors.isProSelector(state),
  isAdmin: UserSelectors.isAdminSelector(state),
});

const withConnect = connect(
  mapStateToProps,
  null,
);

const hasPermissionHOC = permission => InnerComp =>
  withConnect(props => {
    if (true || props.myPermissionArray.includes(permission)) {
      return <InnerComp {...props} />;
    }

    return <NotPermission />;
  });

const HasPermissionHelper = props => {
  if (props.myPermissionArray.includes(props.permission)) {
    return props.children;
  }

  return null;
};

const ProRouterPermission = props => {
  if (props.isPro) {
    return <Route {...props} />;
  }

  return <Redirect from={props.path} to={props.redirect ? props.redirect : '/search/'} />;
};

const AdminPermission = props => {
  if (props.isAdmin) {
    return <Route {...props} />;
  }

  return <Redirect from={props.path} to={props.redirect ? props.redirect : '/manage/'} />;
};

const ProAdminPermission = props => {
  if (props.isPro && props.isAdmin) {
    return <Route {...props} />;
  }

  return <Redirect from={props.path} to={props.redirect ? props.redirect : '/manage/'} />;
};

const LoggedPermission = props => {
  if (props.isLogged) {
    return <Route {...props} />;
  }

  return <Redirect from={props.path} to={props.redirect ? props.redirect : '/search/'} />;
};

const HasPermission = withConnect(HasPermissionHelper);
const ProRoute = withConnect(ProRouterPermission);
const ProAdminRoute = withConnect(ProAdminPermission);
const AdminRoute = withConnect(AdminPermission);
const LoggedRoute = withConnect(LoggedPermission);

export { HasPermission, hasPermissionHOC, PERMISSION_TYPES, ProRoute, LoggedRoute, ProAdminRoute, AdminRoute };
